<template>
  <div class="torrey-container">
    <div class="torrey">
      <!-- <div class="foliageContainer"> -->
        <a 
          target="_blank"
          :href="torrey.ExternalLink"
          class="foliage"
          :class="{
            active: torrey
          }"
        >
          <LeafCluster 
            v-for="leaf in leaves"
            :key="leaf.x*leaf.y"
            :x=leaf.x 
            :y=leaf.y
            :r=leaf.r
          />  
        </a>
      <!-- </div> -->
      <div class="branches">
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <!-- <LeafCluster />   -->
        </div>
        <div class="branch">
          <!-- <LeafCluster />   -->
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <!-- <LeafCluster />   -->
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <!-- <LeafCluster />   -->
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <!-- <LeafCluster />   -->
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <!-- <LeafCluster />   -->
        </div>
        <div class="branch">
          <!-- <LeafCluster />   -->
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
        <div class="branch">
          <LeafCluster />  
        </div>
      </div>
      <div class="trunk">
        <div>
          <div class="side-trunk">
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import LeafCluster from './LeafCluster.vue'
import leavesJSON from '../leaves.json'

export default {
  components: { LeafCluster },
  name: "Torrey",
  props: [
    'torrey',
  ],
  created() {
    // let x = () => { return Math.floor(Math.random() * (800 - 200) + 200) }
    // let y = () => { return Math.floor(Math.random() * (280 - 150) + 150) }
    // let r = () => { return Math.floor(Math.random() * (250 - 215) + 215) }

    // for (let i = 0; i < 20; i ++) {
    //   let newLeaf = { x: x(), y: y(), r: r() }
    //   this.leaves.push(newLeaf)
    // }
    // console.log(this.leaves)
  },
  data () {
    return {
      leaves: leavesJSON.leaves
      // leaves: []
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.torrey {
  cursor: default;
}
.torrey:hover {
  cursor: default;
}
.torrey.active {
  cursor: pointer;
}
.torrey.active:hover {
  cursor: pointer;
}
.torrey-container {
  align-self: flex-end;
  height: 100vh;
  max-height: 1500px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  overflow-x: visible;
  overflow-y: hidden;

}
.torrey {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: hidden;
  --light-brown: rgb(165, 132, 101);
  --dark-brown: rgb(78,65,51);
}
.torrey .branches {
  margin-top: -100px;
  margin-bottom: 30px;
  margin-right: 17px;
  height: 100px;
  width: 750px;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  z-index: 1;
}
.torrey .branches .branch {
  width: 130px;
  height: 20px;
  border-left: 10px ridge rgb(165, 132, 101);
  border-bottom: 10px ridge rgb(165, 132, 101);
  border-bottom-left-radius: 65% 20px;
}
.torrey .branches .branch:before {
  content: '';
  position: absolute;
  left: -40px;
  top: -10px;
  height:  20px;
  width: 30px;
  border-right: 10px ridge rgb(165, 132, 101);
  border-top-left-radius: 25% 10px;
  border-top-right-radius: 20% 15px;
}
.torrey .branches .branch:after {
  content: '';
  position: absolute;
  right: -30px;
  bottom: -40px;
  height:  30px;
  width: 30px;
  border-top: 10px ridge rgb(165, 132, 101);
  border-right: 10px ridge rgb(165, 132, 101);
  border-bottom-right-radius: 100% 10px;
  border-top-right-radius: 65% 20px;
}
.torrey .branches .branch:nth-of-type(-n+8) {
  height: 20px;
  margin-top: -30px;
  margin-right: 40px;
  width: 40px;
  transform: scale(1);
}
.torrey .branches .branch:nth-of-type(-n+8):after {
  height: 20px;
  width: 25px;
  right: -35px;
  bottom: -30px;
  border-top-right-radius: 65% 20px;
}
.torrey .branches .branch:nth-of-type(n+9):nth-of-type(-n+14) {
  height: 50px;
  width: 140px;
  margin-top: -35px;
  border-width: 12px;
  margin-right: -60px;
  transform: scale(1.1);
  border-bottom-width: 16px;
  border-bottom-left-radius: 65% 30px;
}
.torrey .branches .branch:nth-of-type(15) {
  width: 80px;
  height: 60px;
  margin-top: -45px;
  margin-right: 0px;
  border-width: 12px;
  border-bottom-width: 16px;
  transform: scale(1.1);
}
.torrey .branches .branch:nth-of-type(16) {
  width: 40px;
  margin-right: -20px;
  height: 60px;
  margin-top: -45px;
  border-width: 12px;
  border-bottom-width: 16px;
  transform: scale(1.1);
}
.torrey .branches .branch:nth-of-type(n+9):nth-of-type(-n+16):before {
  width: 80px;
  left: -92px;
  height: 20px;
  top: -19px;
  border-top-right-radius: 15% 15px;
  border-width: 12px;
}
.torrey .branches .branch:nth-of-type(9):after {
  display: none;
}
.torrey .branches .branch:nth-of-type(n+10):nth-of-type(-n+16):after {
  border-bottom-right-radius: 15% 20px;
  bottom: -36px;
  height: 20px;
  border-width: 16px;
}
.torrey .branches .branch:nth-of-type(10):after {
  height: 10px !important;
  bottom: -26px !important;
}
.torrey .branches .branch:nth-of-type(n+17):nth-of-type(-n+21) {
  height: 110px;
  margin-top: -90px;
  width: 165px;
  margin-right: -84px;
  border-width: 10px;
  border-bottom-width: 24px;
  transform: scale(1.1);
  border-bottom-left-radius: 65% 60px;
}
.torrey .branches .branch:nth-of-type(17) {
  height: 100px !important;
  border-bottom-width: 30px !important;
}
.torrey .branches .branch:nth-of-type(18) {
  height: 100px !important;
  border-bottom-width: 30px !important;
}
.torrey .branches .branch:nth-of-type(19) {
  height: 140px !important;
  border-bottom-width: 40px !important;
  z-index: 1 !important;
}
.torrey .branches .branch:nth-of-type(20) {
  height: 100px !important;
  border-bottom-width: 40px !important;
}
.torrey .branches .branch:nth-of-type(21) {
  height: 135px !important;
  border-bottom-width: 30px !important;
  width: 120px !important;
  margin-right: -70px !important;
}
.torrey .branches .branch:nth-of-type(n+17):nth-of-type(-n+21):before {
  width: 60px;
  left: -70px;
  top: -20px;
  border-width: 10px;
  border-top-right-radius: 65% 35px;
}
.torrey .branches .branch:nth-of-type(n+19):nth-of-type(-n+21):after {
  width: 50px;
  bottom: -70px;
  height: 30px;
  right: -30px;
  border-width: 40px;
  border-right-width: 40px;
  border-bottom-right-radius: 0px;
}
.torrey .branches .branch:nth-of-type(n+18):after {
  bottom: -60px;
  border-width: 30px;
}
.torrey .branches .branch:nth-of-type(20):after {
  right: -15px !important;
}
.torrey .branches .branch:nth-of-type(21):after {
  right: -15px !important;
  border-width: 20px !important;
}


.torrey .branches .branch:nth-last-of-type(4),
.torrey .branches .branch:nth-last-of-type(3),
.torrey .branches .branch:nth-last-of-type(2),
.torrey .branches .branch:nth-last-of-type(1) {
  margin-right: 10px;
  margin-top: -10px;
  width: 100px;
  transform: scale(2.52);
  border-width: 12px;
  display: none;
}
.torrey .branches .branch:nth-last-of-type(2):after,
.torrey .branches .branch:nth-last-of-type(1):after { 
  right: -10px;
  border-width: 15px;
}



.torrey .trunk {  
  height: 80%;
  z-index: 1;
  margin-right: -20px;

}
.torrey .trunk div {
  width: 50px;
  background: linear-gradient(to right, 
    var(--dark-brown) 0%, 
    var(--light-brown) 30%, 
    var(--light-brown) 70%, 
    var(--dark-brown) 100%
  );
}

.torrey .trunk div:nth-of-type(1) {
  height: 20%;
  transform: scaleY(1.1) rotate(4deg) scaleY(1.1);
  transform-origin: bottom left;
  z-index: 1;
}
.torrey .trunk div:nth-of-type(2) {
  height: 30%;
  transform-origin: top left;
}
.torrey .trunk div:nth-of-type(3) {
  margin-top: -30px;
  height: 60%;
  transform: rotate(3deg);
  transform-origin: top left;
}
.torrey .trunk div .side-trunk {
  position: absolute;
  top: 70px;
  right: 10px;
  height: 70px;
  transform: scaleY(1) rotate(-36deg);
  transform-origin: bottom left;
}
.torrey .trunk div .side-trunk:before {
  content: '';
  position: absolute;
  top: -45px;
  height: 50px;
  width: 50px;
  border-top-left-radius: 50% 45px;
  background: linear-gradient(to right, 
    var(--dark-brown) 0%, 
    var(--light-brown) 30%, 
    var(--light-brown) 70%, 
    var(--dark-brown) 100%
  );
}
.torrey .trunk div .side-trunk:after {
  content: '';
  position: absolute;
  bottom: -35px;
  height:  60px;
  width: 50px;
  background: linear-gradient(to right, 
    var(--dark-brown) 0%, 
    var(--light-brown) 30%, 
    var(--light-brown) 70%, 
    var(--dark-brown) 100%
  );
  border-radius: 100%;
}
.torrey .foliage {
  position: relative;
  margin-top: 20px;
  height: 350px;
  width: 900px;
  z-index: 2;
  overflow-x: visible;
  /* display: flex; */
  /* flex-flow: row wrap; */
  /* justify-content: flex-end; */
  /* align-content: flex-end; */
  /* opacity: 0; */
}
.torrey .foliage .cluster {
  /* position: relative; */
  /* width: 80px; */
}
/* .torrey .foliage .cluster:first-of-type {

} */



</style>


